import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import { ElMessage } from 'element-plus';
import { defineComponent, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import UserService from '@/api/user';
import { loginUrlMap, locationHost } from '@/config/constant';
import { genHrefOpenUrlNoDecode } from '@/utils/login';
export default defineComponent({
  setup: function setup() {
    var route = useRoute();
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _route$query$app_key, _route$query$redirect, _data$data;

      var data, _data$data$result, status, redirect_url, host, redirectUrl;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return UserService.checkLogin({
                app_key: ((_route$query$app_key = route.query.app_key) === null || _route$query$app_key === void 0 ? void 0 : _route$query$app_key.toString()) || '',
                redirect_url: encodeURIComponent(decodeURIComponent(((_route$query$redirect = route.query.redirect_url) === null || _route$query$redirect === void 0 ? void 0 : _route$query$redirect.toString()) || ''))
              });

            case 2:
              data = _context.sent;

              if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                _data$data$result = data.data.result, status = _data$data$result.status, redirect_url = _data$data$result.redirect_url;

                if (status === 0) {
                  location.href = genHrefOpenUrlNoDecode(redirect_url);
                } else {
                  host = loginUrlMap[locationHost];
                  redirectUrl = encodeURIComponent(redirect_url);
                  location.href = host ? "".concat(host).concat(redirectUrl) : genHrefOpenUrlNoDecode("/login?redirect_url=".concat(redirectUrl));
                }
              } else {
                ElMessage({
                  message: data.data.msg,
                  type: 'error'
                });
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
  }
});